module.exports = __webpack_public_path__ + "img/banner-img1.3d9ca574.png";